import { BlockModule } from './common'

new BlockModule({
    selector: '.block-icon-text-list',
    // inViewDebugMode: true,
})
